export const COOKIE_TDE_PROXY = 'tde_proxy';
export const COOKIE_TDE_PROXY_TRUE = '1';
export const COOKIE_TDE_PROXY_FALSE = '0';

export const X_FROM_TDE = 'x-from-tde';
